import { useTranslation } from "react-i18next";

const ASQI_PAYOUT_PER_KG = 0.75;
const FARMER_PAYOUT_PER_KG = 2;

export const getProcurementEstimatedPayout = (
  quantity_kg,
  transportation_by
) => {
  if (!quantity_kg || !transportation_by) {
    return 0;
  }
  if (transportation_by === "FARMER") {
    return (quantity_kg * FARMER_PAYOUT_PER_KG).toFixed(2);
  }
  return (quantity_kg * ASQI_PAYOUT_PER_KG).toFixed(2);
};

export const getProcurementNextAction = (
  procurement_id,
  procurement_status,
  role
) => {
  const { t } = useTranslation();
  if (role === "FARMER") {
    if (procurement_status === "ACCEPTED") {
      return {
        path: `/procurement/pickup-request/${procurement_id}`,
        label: t("Request Pickup"),
      };
    }
    return {
      path: `/procurement/${procurement_id}`,
      label: t("View Details"),
    };
  }
  if (["VLE", "AREA_MANAGER"].includes(role)) {
    if (procurement_status === "PLACED") {
      return {
        path: `/procurement/schedule-inspection/${procurement_id}`,
        label: t("Schedule Inspection"),
      };
    }
    if (procurement_status === "INSPECTION_SCHEDULED") {
      return {
        path: `/procurement/inspection/${procurement_id}`,
        label: t("Conduct Inspection"),
      };
    }
    if (procurement_status === "PICKUP_SCHEDULED") {
      return {
        path: `/procurement/pickup/${procurement_id}`,
        label: t("Schedule Pickup"),
      };
    }
  }
  return {
    path: `/procurement/${procurement_id}`,
    label: t("View Details"),
  };
};
